import { styled } from '@mui/material/styles'
import { IconButton } from '@mui/material'

export const IconBtn = styled(IconButton)(() => ({
  '*': {
    cursor: 'pointer',
  },
}))
